export type OffersVisibility = "hideOffersHomepage" | "hideOffersCollection";

export function filterByVisibility<T extends object>(
  offers: T[] | undefined,
  offersVisibility: OffersVisibility
): T[] | undefined {
  return offers?.filter((offer) => {
    if (
      offersVisibility == "hideOffersHomepage" &&
      "hideInHomepage" in offer &&
      offer.hideInHomepage
    )
      return false;

    if (
      offersVisibility == "hideOffersCollection" &&
      "hideInCollections" in offer &&
      offer.hideInCollections
    )
      return false;

    return true;
  });
}
